import * as React from 'react';
import { default as BaseModal } from '@mui/material/Modal';
import { ReactElement } from 'react';
import Box from '@mui/material/Box';

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    width: 'min(92vw, 880px)',
    minWidth: 650,
    maxHeight: '90vh',
    overflow: 'auto',

    bgcolor: '#ffffff',
    border: '1px solid #e6eaf0',
    borderRadius: '28px',
    boxShadow: '0 24px 80px rgba(15, 23, 42, 0.18)',

    p: { xs: 3, md: 5 },

    outline: 'none',

    '&::-webkit-scrollbar': {
        width: 8,
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#cbd5e1',
        borderRadius: 999,
    },

    '@media (max-width: 720px)': {
        width: '92vw',
        minWidth: 'unset',
    },

    '@media (max-width: 570px)': {
        width: '94vw',
        p: 2,
        borderRadius: '20px',
    },
};

interface ModalProps {
    isOpen: boolean;
    handleClose: (event?: {}, reason?: 'backdropClick' | 'escapeKeyDown') => void;
    children: ReactElement;
    className?: string;
}

const Modal: React.FC<ModalProps> = ({ handleClose, isOpen, children, className }) => {
    return (
        <BaseModal
            open={isOpen}
            onClose={handleClose}
            className={className}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(15, 23, 42, 0.45)',
                        backdropFilter: 'blur(4px)',
                    },
                },
            }}
        >
            <Box sx={style} className={className}>
                {children}
            </Box>
        </BaseModal>
    );
};

export default Modal;
